var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.696,
    height: 16.696,
    viewBox: "0 0 16.696 16.696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check_circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.2;}.b{fill:none;}.c{fill:#11232e;}.d,.e{stroke:none;}.e{fill:#11232e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.348,0A8.348,8.348,0,1,1,0,8.348,8.348,8.348,0,0,1,8.348,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 8.34782600402832 0.9999961853027344 C 4.296216011047363 0.9999961853027344 0.9999961853027344 4.296216011047363 0.9999961853027344 8.34782600402832 C 0.9999961853027344 12.39943599700928 4.296216011047363 15.69565582275391 8.34782600402832 15.69565582275391 C 12.39943599700928 15.69565582275391 15.69565582275391 12.39943599700928 15.69565582275391 8.34782600402832 C 15.69565582275391 4.296216011047363 12.39943599700928 0.9999961853027344 8.34782600402832 0.9999961853027344 M 8.34782600402832 -3.814697265625e-06 C 12.95820617675781 -3.814697265625e-06 16.69565582275391 3.737445831298828 16.69565582275391 8.34782600402832 C 16.69565582275391 12.95820617675781 12.95820617675781 16.69565582275391 8.34782600402832 16.69565582275391 C 3.737445831298828 16.69565582275391 -3.814697265625e-06 12.95820617675781 -3.814697265625e-06 8.34782600402832 C -3.814697265625e-06 3.737445831298828 3.737445831298828 -3.814697265625e-06 8.34782600402832 -3.814697265625e-06 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.275,11.626.141,8.493a.482.482,0,0,1,0-.682l.682-.682a.482.482,0,0,1,.682,0L3.616,9.24,8.138,4.718a.482.482,0,0,1,.682,0L9.5,5.4a.482.482,0,0,1,0,.682L3.957,11.626A.482.482,0,0,1,3.275,11.626Z",
    transform: "translate(4 0.422)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.134134026d260781bb8a28e3cd451237.svg";
export { ForwardRef as ReactComponent };